<template>
    <div>
        <v-btn color="primary" @click="abrirDialog()" outlined>
            Nuevo parte <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
        <v-dialog v-model="dialogNuevoParte" max-width="600px" persistent>
          <v-card>
            <v-card-title><span class="headline">Nuevo parte</span></v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete 
                            v-model="clienteSeleccionado" 
                            :items="clientes" 
                            @input="$v.clienteSeleccionado.$touch()"
                            @blur="$v.clienteSeleccionado.$touch()"
                            :error-messages="errorCliente"
                            chips 
                            label="Cliente" 
                            item-text="name" 
                            item-value="name" 
                            return-object
                            ref="inputCrear"
                            autofocus
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="tecnicoSeleccionado"
                            :items="tecnicos"
                            @input="$v.tecnicoSeleccionado.$touch()"
                            @blur="$v.tecnicoSeleccionado.$touch()"
                            :error-messages="errorTecnico"
                            chips
                            label="Técnico asignado"
                            item-text="name"
                            item-value="id"
                            return-object
                        >
                            <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs" :input-value="data.selected" @click="data.select">
                                <v-avatar left :color="data.item.color">
                                    <span class="white--text">{{ data.item.avatar }}</span>
                                </v-avatar>
                                {{ data.item.name }}
                            </v-chip>
                            </template>
                            <template v-slot:item="data">
                            <template>
                                <v-list-item-avatar :color="data.item.color">
                                    <span class="white--text">{{ data.item.avatar }}</span>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ data.item.apellidos }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="concepto"
                            label="Concepto"
                            maxlength="35"
                            counter
                          ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea 
                            label="A realizar" 
                            v-model="aRealizar"
                            @input="$v.aRealizar.$touch()"
                            @blur="$v.aRealizar.$touch()"
                            :error-messages="errorRealizar"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="cerrar()">Cerrar</v-btn>
              <v-btn 
                color="blue darken-1" 
                text 
                @click="aceptar()" 
                :disabled="$v.$invalid"
                :loading="loading"
            >Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { required } from 'vuelidate/lib/validators';
    import { mapActions } from 'vuex';
    import Parte from '@/classes/Parte';
    import axios from 'axios';
    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    export default {
        data() {
            return {
                dialogNuevoParte: false,
                concepto: 'Tareas varias',
                aRealizar: 'Tareas varias',
                tecnicoSeleccionado: {
                    id: 6
                },
                clienteSeleccionado: {},
                loading: false
            }
        },
        props: ["usuarios", "clientes"],
        methods: {
            ...mapActions(["setSnackbar"]),
            abrirDialog(){
                console.log("Abrir dialog");
                this.dialogNuevoParte = true;
            },
            cerrar(){
                console.log("Cerrar");
                this.reset();
                this.dialogNuevoParte = false;
            },
            reset(){
                this.clienteSeleccionado = {};
                this.tecnicoSeleccionado = {
                    id: 6
                };
                this.concepto = "Tareas varias";
                this.aRealizar = "Tareas varias";
                this.$v.$reset();
            },
            async aceptar(){
                console.log("Aceptar");
                console.log(this.clienteSeleccionado);
                console.log(this.tecnicoSeleccionado);
                this.loading = true;
                let comercialReferencia = this.comerciales.find(comercial => comercial.email === this.clienteSeleccionado.comercialEmail);
                
                try{
                    let delegaciones = (await axios.get(`/api/delegaciones?codCliente=${this.clienteSeleccionado.code}`))?.data;
                    if(delegaciones.length > 0){
                        let parteNuevo = new Parte({
                            cliente_id: this.clienteSeleccionado.code,
                            cliente: this.clienteSeleccionado.name,
                            user_id: this.tecnicoSeleccionado.id,
                            comercial_id: comercialReferencia?.id,
                            concepto: this.concepto,
                            realizar: this.aRealizar,
                            delegacion_id: delegaciones[0].delegacionId
                        });
                        console.log(parteNuevo);
                        try{
                            await axios.post('/api/partes', parteNuevo);
                            this.$emit("actualizarPartes"); //******** */
                        }catch(error){
                            this.setSnackbar({
                                tipo: 'error',
                                mensaje: 'Error. No se ha podido crear el parte.'
                            });
                        }
                    }else{
                        this.setSnackbar({
                            tipo: 'warning',
                            mensaje: 'El cliente no tiene delegaciones informadas en BC. No es posible crear el parte.'
                        });
                    }
                    this.cerrar();
                }catch (error){
                    // console.log(error);
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. No se han podido recuperar las delegaciones del cliente seleccionado.'
                    });
                }finally{
                    this.loading = false;
                }
            }
        },
        validations: {
            clienteSeleccionado: { required },
            tecnicoSeleccionado: { required },
            aRealizar: { required },
        },
        computed: {
            tecnicos(){
                return this.usuarios.filter(usuario => usuario.grupos.find(grupo => grupo.id === 2)); // Grupo id 2 => técnicos
            },
            comerciales(){
                return this.usuarios.filter(usuario => usuario.grupos.find(grupo => grupo.id === 3)); // Grupo id 3 => comerciales
            },
            errorCliente(){
                if (this.$v.clienteSeleccionado.$dirty) {
                    if (this.$v.clienteSeleccionado.$invalid) {
                        return "Selecciona un cliente";
                    }
                }
            },
            errorTecnico(){
                if (this.$v.tecnicoSeleccionado.$dirty) {
                    if (this.$v.tecnicoSeleccionado.$invalid) {
                        return "Selecciona un técnico";
                    }
                }
            },
            errorRealizar() {
                if (this.$v.aRealizar.$dirty) {
                    if (this.$v.aRealizar.$invalid) {
                        return "Introduce las tareas a realizar del parte";
                    }
                }
            },
        }
    }
</script>
